import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUndoToolbar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M1.5 18.8801H17.25C17.9404 18.8801 18.5 18.3205 18.5 17.6301V8.64001C18.5 7.94966 17.9404 7.39001 17.25 7.39001H9.75H1.55468",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.54678 1.85327L1 7.40006L6.54678 12.9468",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "round"
	})]
});
export default SvgUndoToolbar;
